/**
 * CardPlayIcon – SVG icon.
 */
import IArrow from '@shared/types/props/arrow';
import Screen from '@screen';

/** Play icon for content cards. */
export default function CardPlayIcon({
  focused,
  ratio = 1,
  height = 20,
  width = 17,
}: IArrow) {
  return (
    <svg
      width={`${width * ratio * Screen.widthRatio}`}
      height={`${height * ratio * Screen.widthRatio}`}
      viewBox='0 0 17 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.3446 0.122289C1.66781 -0.0530018 2.06158 -0.0389906 2.37134 0.158822L16.4647 9.15882C16.7528 9.34282 16.927 9.65974 16.927 10C16.927 10.3403 16.7528 10.6572 16.4647 10.8412L2.37134 19.8412C2.06158 20.039 1.66781 20.053 1.3446 19.8777C1.02138 19.7024 0.820312 19.3658 0.820312 19V1C0.820312 0.634194 1.02138 0.297579 1.3446 0.122289ZM2.83365 2.83167V17.1683L14.0587 10L2.83365 2.83167Z'
        fill={focused ? 'black' : 'white'}
      />
    </svg>
  );
}
